// Web: the open animation is classes on the content
export const dropdownContentEnterFadeMs = undefined;
